<template>
  <div v-for="(item,index) in forumTypeList" :key="index">
    <div>
      <va-icon v-if="index == 0" name="library_books" size="26px" color="blank" style="margin-right: 4px;"/>
      <va-icon v-else name="radio" size="26px" color="work" style="margin-right: 4px;"/>

      <!-- <va-icon class="icon-left input-icon" name="insert_comment"/> -->
      <b style="margin-left:3px;">{{ item.Name }}</b>
    </div>
    <div class="row" style="margin-bottom: 100px;">
      <div class="flex xs4 operation-content" v-for="(itm,idx) in forumTypeList[index].sectionList" :key="idx"
        @click="skipPostspage(itm)">
        <div class="flex x5 md5 xs5" v-if="index < 1">
          <div class="operation">
            <img :src="imgList1[idx]" alt=""/>
          </div>
        </div>
        <div class="flex x5 md5 xs5" v-else>
          <div class="operation">
            <img :src="imgList2[idx] || emptyIcon" alt=""/>
          </div>
        </div>
        <div class="flex x7 md7 xs7">
          <div class="operation-msg">{{ itm.Name }}</div>
          <div class="operation-question">{{ itm.Remark }}</div>
          <div class="operation-invitation"><span>贴数:{{ itm.ArticleCount }}</span> <span>回复:{{ itm.ReplyCount }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ref,
  reactive,
  defineComponent,
  toRaw,
  watchEffect,
  watch,
  nextTick,
  onMounted,
  getCurrentInstance,
  toRefs
} from 'vue'
import Qs from 'qs';

export default defineComponent({
  name: "forumContent",
  props: {
    pushdata: {
      type: Object
    }
  },
  components: {
    // forumContent
  },
  data() {
    return {
      imgList1: [

        require('@/static/images/icon/cjwd.png'),
        require('@/static/images/icon/kczy.png'),
        require('@/static/images/icon/mbytz.png'),
      ],
      imgList2: [
        require('@/static/images/icon/rpa.png'),
        require('@/static/images/icon/pycodeeasy.png'),
        require('@/static/images/icon/python.png'),
        require('@/static/images/icon/tableau.png'),
        require('@/static/images/icon/teambition.png'),
        require('@/static/images/icon/dd_light_blue.png'),
        require('@/static/images/icon/ai.png'),
        require('@/static/images/icon/ddmkf.png'),
        require('@/static/images/icon/qt.png')
      ],
      emptyIcon: require("@/static/images/learnIcon/其他系统.svg"),
      forumTypeList: [],
      forumSection: [],
      dataList2: []
    }
  },
  mounted() {
    this.getForumType().then((ress) => {
      // console.log(ress)
      this.getForumSection(ress)
    })
  },
  methods: {
    skipPostspage(params) {
      // let forumPageData = {
      //   sectionID: params.ID,
      //   sectionName: params.Name,
      //   labelID: '',
      //   labelName: ''
      // };
      let forumPageData = {
        sectionID: params.ID,
        sectionName: params.Name,
        labelID: '',
        labelName: '',
        pageIndex: 1,
        pageSize: 10,
        TimeSpan: '0',
        Order: '0'
      };
      this.$store.commit('updateForumPageData', forumPageData)

      console.log(params)
      this.$router.push({path: '/admin/forum/postsPage/index'})
    },
    //获取板块类型
    getForumSection(paramData) {
      let resData,
        forumTypeList = paramData;
      const params = {
        "Name": "",
      };
      this.$api.formsAPI.getForumSection(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          resData = res.data.Data;
          // this.forumSection = resData;
          paramData.map((item, index) => {
            forumTypeList[index]['sectionList'] = [];
            resData.forEach((itm, idx) => {
              if (item.Name == itm.TypeName) {
                forumTypeList[index]['sectionList'].push(itm)

              }
            })
          })
          //  that.nextTick(()=>{
          this.forumTypeList = forumTypeList;
          // })

          console.log('forumTypeList111',toRaw(this.forumTypeList))
        })
        .catch(error => {
          console.log(error);
        })
    },
    //获取板块类型
    async getForumType() {
      let resData;
      const params = {
        "Name": "",
      };
      await this.$api.formsAPI.getForumType(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          // this.forumTypeList = res.data.Data;
          resData = res.data.Data;
        })
        .catch(error => {
          console.log(error);
        })
      return resData;
    },
  },


})
</script>
<style scoped lang="scss">
.technology .operation-content {
  margin: 1.8rem 0;
  padding: 0 0.75rem !important;
}

.operation-content {
  flex-wrap: nowrap;
  display: flex;

  > div {
    display: inline-block;
    vertical-align: middle;
  }

  div:first-child {
    margin-right: 10px;
    color: #333;
  }

  &:hover {
    box-shadow: 0 0 3px 0 rgb(0 0 0 / 20%);
    cursor: pointer;
    background: #f9f9f9;
  }
}

.operation {
  width: 90px;
  height: 90px;
  margin: 0 auto;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  border-radius: 50%;
  background: #f7f7fa;
  overflow: hidden;

  img {
    filter: invert(55%) sepia(46%) saturate(3903%) hue-rotate(185deg) brightness(89%) contrast(104%);
    width: 60px;
    height: 60px;
    display: block;
  }
}

.operation-msg {
  margin: 2px 0 10px;
}

.operation-question {
  line-height: 20px;
  font-size: 13px;
  margin-bottom: 8px;
  // padding-right: 30px;
  box-sizing: border-box;
  color: #666;
}

.operation-invitation > span {
  color: #ccc;
  font-size: 13px;
  margin-right: 10px;
}
</style>
